export default "__VITE_ASSET__CQM4vAQP__"